import _ from 'lodash';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import numeral from 'numeral';

import currencyFormat from './currency';

export const formatDataPhone = ( data, fields ) => {
  const formattedData = { ...data };

  _.map( fields, ( field ) => {
    const value = _.get( data, field );
    if ( value && value[0] !== '+' ) _.set( formattedData, field, `+${value}` );
  } );
  return formattedData;
};

export const formatPhone = ( value ) => {
  let newValue = value;
  if ( value && value[0] !== '+' ) newValue = `+${value}`;

  return newValue && parsePhoneNumberFromString( newValue )
    ? parsePhoneNumberFromString( newValue ).format( 'INTERNATIONAL' ) : newValue;
};

export const formatDataPhoneToSend = ( data, fields ) => {
  const formattedData = { ...data };

  _.map( fields, ( field ) => {
    let value = _.get( data, field );
    if ( value ) {
      if ( value[0] === '+' ) value = value.slice( 1 );
      _.set( formattedData, field, `${value.replace( /[^0-9]+/g, '' )}` );
    }
  } );
  return formattedData;
};

export const getPhoneCountryCode = ( value ) => {
  const phoneCountryCode = parsePhoneNumberFromString( value );
  return phoneCountryCode ? phoneCountryCode.countryCallingCode : null;
};

export const formatFloat = ( value ) => {
  let newValue = _.clone( value );
  if ( value ) newValue = value / 100;
  return newValue;
};

export const formatFloatToSend = ( value ) => {
  let newValue = _.clone( value );
  if ( value ) newValue = ( Math.round( value * 100 ) / 100 ) * 100;
  return newValue;
};

export const formatDataToSend = ( formData, form ) => {
  const dataToSend = {};
  _.map( _.keys( form.getState().modified ), ( key ) => {
    if ( _.get( formData[key], 'id' ) ) {
      _.set( dataToSend, key, _.get( formData, `${key}.id` ) );
    } else if ( formData.id ) {
      if ( _.isArray( formData[key] ) && _.get( formData, `${key}.0.value` ) && _.get( formData, `${key}.0.label` ) ) {
        _.set( dataToSend, key, _.map( formData[key], 'value' ) );
      } else if ( _.isObject( formData[key] ) && formData[key].value && formData[key].label ) {
        _.set( dataToSend, key, formData[key].value );
      } else {
        _.set( dataToSend, key, _.get( formData, key, '' ) );
      }
    } else if ( _.isArray( formData[key] ) && _.get( formData, `${key}.0.value` ) && _.get( formData, `${key}.0.label` ) ) {
      _.set( dataToSend, key, _.map( formData[key], 'value' ) );
    } else if ( _.isObject( formData[key] ) && formData[key].value && formData[key].label ) {
      _.set( dataToSend, key, formData[key].value );
    } else {
      _.set( dataToSend, key, _.get( formData, key ) );
    }
  } );
  return dataToSend;
};

export const formatFormDataBody = ( data ) => {
  const formData = new FormData();

  _.forEach( data, ( value, key ) => {
    if ( value ) formData.append( key, value );
  } );

  return formData;
};


export const formatNumeral = ( number ) => numeral( number || 0 ).format( currencyFormat( '' ) );
